import { t } from '@trimble/i18n';
import { JSX } from 'solid-js';
import { leftClickIcon, mouseScrollIcon, rightClickIcon } from './Icons';

export const AlignmentNavigationInstructionsPanel = (): JSX.Element => {
  return (
    <div
      class="absolute top-full right-0 mt-1 bg-base-page border py-4 px-2 border-[var(--modecolor-modecontent-level2,#e0e1e9)] rounded-sm shadow-[0px_4px_6px_-1px_rgba(0,0,0,0.1),0px_2px_4px_-2px_rgba(0,0,0,0.1)] min-w-fit"
      data-testid="alignment-navigation-commands-info-panel"
    >
      <div class="mx-1 flex flex-col min-w-fit">
        <InstructionsRow
          text={t('TC.3D.AlignmentNavigationToolbar.Instructions.Navigate')}
          iconFn={mouseScrollIcon}
        />
        <InstructionsRow
          text={t('TC.3D.AlignmentNavigationToolbar.Instructions.FocusPoint')}
          iconFn={rightClickIcon}
          key={t('TC.3D.AlignmentNavigationToolbar.Drag')}
        />
        <InstructionsRow
          text={t('TC.3D.AlignmentNavigationToolbar.Instructions.PickPath')}
          iconFn={leftClickIcon}
          key={t('TC.3D.AlignmentNavigationToolbar.CTRL')}
          text2={t(
            'TC.3D.AlignmentNavigationToolbar.Instructions.PickPathPrecision'
          )}
        />
        <InstructionsRow
          text={t('TC.3D.AlignmentNavigationToolbar.Instructions.Zoom')}
          iconFn={mouseScrollIcon}
          key={t('TC.3D.AlignmentNavigationToolbar.CTRL')}
        />
        <InstructionsRow
          text={t(
            'TC.3D.AlignmentNavigationToolbar.Instructions.JumpToPosition'
          )}
          iconFn={leftClickIcon}
          key={t('TC.3D.AlignmentNavigationToolbar.CTRL')}
        />
      </div>
    </div>
  );
};

interface InstructionsRowProps {
  text: string;
  iconFn(): JSX.Element;
  key?: string;
  text2?: string;
}

const InstructionsRow = (props: InstructionsRowProps): JSX.Element => {
  return (
    <div class="trimble-model-text text-xs py-[5px] h-[30px] flex flex-row whitespace-nowrap !my-0 !mb-0 !mt-0 !leading-[20px]">
      <div class="flex flex-row justify-end shrink-0 items-center">
        <div class="min-w-[60px] flex flex-row justify-end">
          {props.key && (
            <>
              <modus-wc-badge
                color="tertiary"
                custom-class="rounded-sm mr-1 h-5 w-[27px] font-bold shadow-[0px_1px_1px_0px_rgba(0,0,0,0.25)]"
              >
                <div class="text-[8px]">{props.key}</div>
              </modus-wc-badge>
              <div class="mr-1">+</div>
            </>
          )}
        </div>
        <div class="mr-2.5 pt+4">{props.iconFn()}</div>
      </div>
      <div class="font-semibold mr-1">{props.text}</div>
      {props.text2 && <div class="font-normal">{props.text2}</div>}
    </div>
  );
};
